import gql from 'graphql-tag';

export default gql`
  subscription agentNotification {
    notification: agentNotification {
      action
      data
      timeout
      notificationID
    }
  }
`;
